
import {
  UserGroupIcon,
  Squares2X2Icon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  AcademicCapIcon,
    BookOpenIcon,
  CalculatorIcon,
  BeakerIcon, 
} from "@heroicons/react/24/outline";



export const statsData = [
  {
    id: 1,
    title: "My Applications",
    value: "Access and Start your learning applications",
    icon: UserGroupIcon,
    arrowColor: "text-blue-600",
    link:"/myapplications",
    onclick:'false'
  },
  {
    id: 2,
    title: "Track Progress ",
    value: "View your personal progress, milestones, and achievements",
    icon: Squares2X2Icon,
    arrowColor: "text-green-600",
    link:'/trackprogress',
    onclick:'false'
  },
  {
    id: 3,
    title: "Submit Feedback",
    value: "Share your feedback to improve learning apps",
    icon: ClipboardDocumentListIcon,
    arrowColor: "text-orange-600",
    onclick:'true'
  },
 
];


export const performanceData = [
  { week: "Week 1", avg: 78 },
  { week: "Week 2", avg: 82 },
  { week: "Week 3", avg: 85 },
  { week: "Week 4", avg: 89 },
];

export  const milestones = [
  { name: "Reading Level 3", value: 34.2, color: "bg-green-500" },
  { name: "MathMaster", value: 34.2, color: "bg-blue-500" },
  { name: "Science Fundamentals", value: 34.2, color: "bg-yellow-500" },
  { name: "MathMaster", value: 34.2, color: "bg-orange-500" },
  { name: "MathMaster", value: 34.2, color: "bg-blue-500" },
];



// import { Squares2X2Icon, BeakerIcon, BookOpenIcon } from '@heroicons/react/24/outline';



export const applicationTableHeaders = [
  { key: "application", label: "APPLICATION" },
  { key: "educator", label: "EDUCATOR" },
  { key: "avgScore", label: "AVG SCORE" },
  { key: "location", label: "LOCATION" },
  { key: "usageHours", label: "USAGE HOURS" },
  { key: "completion", label: "COMPLETION" },
];


export const applications = [
  {
    name: 'Math Master',
    icon: Squares2X2Icon,
    educator: {
      name: 'Michel Shen',
      id: 'USR001',
      avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=MS',
    },
    avgScore: 86,
    location: 'California, USA',
    usageHours: 120,
    completion: 86,
  },
  {
    name: 'Science Lab',
    icon: BeakerIcon,
    educator: {
      name: 'Alice Johnson',
      id: 'USR002',
      avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=AJ',
    },
    avgScore: 92,
    location: 'New York, USA',
    usageHours: 80,
    completion: 96,
  },
  {
    name: 'History Hub',
    icon: BookOpenIcon,
    educator: {
      name: 'John Doe',
      id: 'USR003',
      avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=JD',
    },
    avgScore: 78,
    location: 'Texas, USA',
    usageHours: 60,
    completion: 70,
  },
];

export const ProgressBar = ({ percentage }) => {
  const barColor = percentage > '90%' ? 'bg-green-500' : 'bg-orange-500';
  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5">
      <div className={`${barColor} h-2.5 rounded-full`} style={{ width: `${percentage}` }}></div>
    </div>
  );
};